<template>
  <section class="full-width-image-section trails gray-bg">
    <div class="container">
      <div class="text-center">
        <h1 class="trails-header special-header" v-if="customPageTitle">
          {{ customPageTitle }}
        </h1>
      </div>

      <div v-html="customPageHTML"></div>
      <!-- Render the HTML content safely -->
    </div>
  </section>

  <!-- REGISTER FOR WALKS FORM - Compoonents-->
  <UserForm />

  <section class="full-width-image-section footer green-sep"></section>
</template>

<script>
import db from "@/db"; // Import IndexedDB instance
import UserForm from "@/components/Userform.vue";

export default {
  components: {
    UserForm,
  },
  data() {
    return {
      customPageTitle: "",
      customPageHTML: "",
    };
  },
  async mounted() {
    // Fetch the latest header entry from IndexedDB
    const header = await db.header.orderBy("id").last();

    if (header) {
      this.customPageTitle = header.CustomPageTitle;
      this.customPageHTML = header.CustomPageHTML;
    }
  },
};
</script>
<style scoped>
section.full-width-image-section.trails.gray-bg {
  background-color: white;
}
</style>
